import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TVShowListRow, { TVShowListCard } from "./TVShowListRow";
import useLoginCheck from "../util/useLoginCheck";
import Spinner from "../util/Spinner";
import { fetchTVShowLists } from "../slice/tvShowListsSlice";

const TVShowLists = () => {
  const dispatch = useDispatch();
  const { tvShowLists, isLoading, error } = useSelector(
    (state) => state.tvShowLists
  );
  const [shouldRefresh, setShouldRefresh] = useState(true);

  const navigate = useNavigate();

  useLoginCheck();

  useEffect(() => {
    dispatch(fetchTVShowLists());
  }, [dispatch, shouldRefresh]);

  return (
    <div className="max-w-3xl mx-auto p-4">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {tvShowLists && tvShowLists.lists && tvShowLists.lists.length > 0 ? (
            <div>
              <table className="hidden md:table w-full card">
                <colgroup>
                  <col style={{ width: "90%" }} />
                  <col style={{ width: "10%" }} />
                </colgroup>
                <thead>
                  <tr className="text-left text-sm text-stone-500 border-b border-stone-200">
                    <th className="px-3 py-2 font-medium">Name</th>
                    <th className="px-3 py-2 font-medium">Type</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-200">
                  {tvShowLists.lists.map((tvShowList) => {
                    return (
                      <TVShowListRow
                        key={tvShowList.sid}
                        tvShowList={tvShowList}
                      ></TVShowListRow>
                    );
                  })}
                </tbody>
              </table>
              <ul className="md:hidden space-y-3">
                {tvShowLists.lists.map((tvShowList) => (
                  <TVShowListCard key={tvShowList.sid} tvShowList={tvShowList} />
                ))}
              </ul>
            </div>
          ) : (
            <p className="text-stone-500">No TV show lists entered</p>
          )}
        </>
      )}
    </div>
  );
};

export default TVShowLists;
